import { render } from "./VideoDetailsTagList.vue?vue&type=template&id=2d724b68&ts=true"
import script from "./VideoDetailsTagList.vue?vue&type=script&lang=ts"
export * from "./VideoDetailsTagList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__